// Dependencies
import { FC, MouseEventHandler } from "react";

// Components
import Tag from "~/components/Common/Tag";

// Styles
import { StyledButton } from "./WalletChooseType.styled";

interface WalletTypeProps {
  label?: string;
  color: string;
  onClick: MouseEventHandler<HTMLDivElement>;
}

const WalletType: FC<WalletTypeProps> = ({ label, color, onClick }) => {
  return (
    <StyledButton onClick={onClick}>
      <Tag label={label} color={color} />
    </StyledButton>
  );
};

export default WalletType;
